<template>
	<IconButtonLayout
		class="upload-button"
		type="QUATERNARY"
	>
		<FontAwesomeIcon :icon="[ `far`, `cloud-arrow-up` ]" />
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "UploadButton",
	components: {
		IconButtonLayout,
	},
};
</script>
